import { render, staticRenderFns } from "./OtherServices.vue?vue&type=template&id=448f5a8c&scoped=true&v=4"
import script from "./OtherServices.vue?vue&type=script&lang=js&v=4"
export * from "./OtherServices.vue?vue&type=script&lang=js&v=4"
import style0 from "./OtherServices.vue?vue&type=style&index=0&id=448f5a8c&scoped=true&lang=css&v=4"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f5a8c",
  null
  
)

export default component.exports